import logo from '../../assets/images/logo.png'

export default function FallbackPage() {
    return (
        <>
            <div className="d-flex justify-content-center align-items-center" style={{ backgroundColor: '#f9f7f4', height: '100vh' }}>
                <div className="text-white text-center">
                    <img src={logo} alt="lg" className="img-fluid zoom-animation" style={{ maxHeight: '20vh' }}/>
                </div>
            </div>
        </>
    )
}